import React from 'react';
import classes from "../styles.module.scss";
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import Title from '@/ui/Title';

const SpecialismTile = ({ item, activeIndex, index, handleClick }) => {
  const {discipline, link, image} = item;
  const router = useRouter();

  function tileClick() {
    if(index == activeIndex) {
      //router.push(link);
    } else {
      handleClick(index);
    }
  }


  return (
    <div className={`${classes.tile} ${index == activeIndex ? classes.active : ""}`} onClick={() => tileClick()}>
      <img alt={discipline} src={image} className={classes.image} />
      <Link href={`/${item.link}`}>
      <Title title={discipline} tag="div" className={`h4 ${classes.tile_title}`} />
      </Link>
    </div>
  )
}

export default SpecialismTile